import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { SxProps, Theme } from '@mui/material/styles';

export default ({ sx }: { sx?: SxProps<Theme> }) => (
  <Stack sx={sx}>
    <Skeleton variant="rectangular" height={300} sx={{ margin: '5px 0' }} />
    <Skeleton variant="text" height={18} sx={{ margin: '5px 0' }} />
    <Skeleton variant="rectangular" height={30} sx={{ margin: '5px 0' }} />
  </Stack>
);
